class BasicStrategy {
  async start(initalData) {
    await this.$vm.startFlow(initalData)
  }

  async finally(initalData) {
    // 更新数量
    this.$vm.updateAmount()
    // 根据扫到的条码生成厂家原始条码
    this.$vm.createOriginBarCode()
    //
    this.$vm.handlerFinally(initalData)
  }
}

export default BasicStrategy
